import {useEffect, useState} from 'react';
import {Modal, Select, Form, Spin, message} from 'antd';
import {SchoolService} from './SchoolService';
import {CurriculumsService} from '../Curriculums/CurriculumsService';
import {LevelsService} from '../Level/LevelsService';
import {EnrollmentsService} from '../Enrollments/EnrollmentsService';
import {PlansService} from '@PikaDoApp/npm-pikado-logic';
import {LevelUI} from '../Level/LevelTypes';
const schoolsService = new SchoolService();
const curriculumsService = new CurriculumsService();
const levelsService = new LevelsService();

interface EditClassCurriculumLevelsProps {
  classId: string;
  isOpen: boolean;
  onClose?: () => void;
}

export const EditClassCurriculumLevelsModal = ({
  classId,
  isOpen,
  onClose,
}: EditClassCurriculumLevelsProps) => {
  const enrollmentsService = new EnrollmentsService();
  const plansService = new PlansService();
  // Modal visibility control
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  // Form instance
  const [form] = Form.useForm();

  // Dropdown data
  const [curriculums, setCurriculums] = useState<any[]>([]);
  const [levels, setLevels] = useState<LevelUI[]>([]);
  const [curriculumLevels, setCurriculumLevels] = useState<any>([]);
  // Selected values
  const [selectedCurriculumId, setSelectedCurriculumId] = useState<any>();
  const [selectedLevelId, setSelectedLevelId] = useState<string>('');

  // Search state for curriculum
  const [curriculumSearchQuery, setSearchQuery] = useState<string>('');
  const [filteredCurriculums, setFilteredCurriculums] = useState<any[]>([]);
  const [allPlans, setAllPlans] = useState<any[]>([]);
  const [studentsEnrollments, setStudentsEnrollments] = useState<any[]>([]);
  const [reRender, setRerender] = useState<boolean>(false); // Add rerender key
  useEffect(() => {
    getPlans();
  }, []);
  // Sync modal visibility and fetch data
  useEffect(() => {
    setVisible(isOpen);
    if (!isOpen || !classId) {
      setSelectedCurriculumId('');
      setSelectedLevelId('');
      return;
    }

    const fetchClassData = async () => {
      setLoading(true);

      try {
        const classData =
          await schoolsService.getClassSchoolWithStudentsEnrollments(classId);
        let sharedEnrollments = [];
        classData.students.map((student: any) => {
          student.enrollments?.map((enrollment: any) => {
            if (
              enrollment.paymentStatus === 'DONE' &&
              enrollment.package?.packageDuration
            ) {
              sharedEnrollments.push(enrollment);
            }
          });
        });
        setStudentsEnrollments(sharedEnrollments);

        // Fetch curriculums
        const fetchedCurriculums = await curriculumsService.getCurriculums();
        console.log('Curriculums:', fetchedCurriculums);
        setCurriculums(fetchedCurriculums);
        setFilteredCurriculums(fetchedCurriculums);

        // Fetch levels
        const fetchedLevels = await levelsService.getLevels();
        setLevels(fetchedLevels);

        // Match curriculum and level from shared enrollment
        if (sharedEnrollments.length > 0) {
          const enrollmentCurriculum = sharedEnrollments[0].curriculum;
          const matchedCurriculum = fetchedCurriculums.find(
            (c: any) =>
              c.oldId === enrollmentCurriculum.id ||
              c.id === enrollmentCurriculum.id,
          );
          if (matchedCurriculum) {
            console.log('Setting curriculum ID:', matchedCurriculum.id);
            //detect curriculum levels by plans
            detectCurriculumLevelsByPlans(matchedCurriculum.id, fetchedLevels);
            setSelectedCurriculumId(matchedCurriculum.id);
            form.setFieldsValue({curriculum: matchedCurriculum.id});
          }

          // Match level from shared enrollment
          const enrollmentLevel = sharedEnrollments[0].level;
          const matchedLevel = fetchedLevels.find(
            (l: any) =>
              l.oldId === enrollmentLevel.id ||
              l.id === enrollmentLevel.id ||
              l.name === enrollmentLevel.name,
          );
          if (matchedLevel) {
            const levelId = matchedLevel.id || matchedLevel._id;
            console.log('Setting level ID:', levelId, matchedLevel);
            setSelectedLevelId(levelId);
            form.setFieldsValue({level: levelId});
          }
        } else {
          console.log('No shared enrollments found');
          setSelectedCurriculumId('');
          setSelectedLevelId('');
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error(`Error fetching students for class ${classId}:`, error);
      }
    };

    if (allPlans.length > 0) fetchClassData();
  }, [isOpen, classId, allPlans]);

  const getPlans = async () => {
    try {
      const plans = await plansService.findAllPlans();
      setAllPlans(plans);
    } catch (error) {
      console.error('Error fetching plans:', error);
    }
  };

  // Curriculum search filtering
  useEffect(() => {
    if (curriculumSearchQuery.trim() === '') {
      setFilteredCurriculums(curriculums);
    } else {
      const filtered = curriculums.filter((c: any) =>
        c.name.toLowerCase().includes(curriculumSearchQuery.toLowerCase()),
      );
      setFilteredCurriculums(filtered);
    }
  }, [curriculumSearchQuery, curriculums]);

  // Modal handlers
  const handleOk = async () => {
    if (loading) return;
    await updateStudentsEnrollments();
  };
  const updateStudentsEnrollments = async () => {
    try {
      setLoading(true);
      debugger;
      const oldCurriculumId = curriculums.find(
        c => c.id === selectedCurriculumId,
      );
      const oldLevelId = levels.find(
        l => l.id === selectedLevelId || l._id === selectedLevelId,
      );
      const curId = oldCurriculumId.oldId ?? oldCurriculumId.id;
      const levlId = oldLevelId.oldId ?? oldLevelId.id;

      if (curId && levlId) {
        // Add await here to wait for all promises to complete
        await Promise.all(
          studentsEnrollments.map(async (enrollment: any) => {
            debugger;
            const updatedEnrollment = await enrollmentsService.updateEnrollment(
              {
                id: enrollment.id,
                curriculumId: curId,
                levelId: levlId,
              },
            );
            console.log('Updated Enrollment:', updatedEnrollment);
          }),
        );

        // This will now execute after all updates are complete
        setLoading(false);
        message.success('Successfully Updated Students');
        setVisible(false);
        onClose?.();
      }
    } catch (error) {
      setLoading(false);
      message.error(error.message);
      console.error("Error updating students' enrollments:", error.message);
    }
  };
  const handleCancel = () => {
    if (loading) return;
    setVisible(false);
    onClose?.();
  };

  // Update the function signature to accept levels as a parameter
  const detectCurriculumLevelsByPlans = async (
    curriculumId: string,
    levelsData?: any[],
  ) => {
    try {
      const plansForCurriculum = allPlans.filter(
        (plan: any) => plan.curriculum === curriculumId,
      );

      const levelIds = plansForCurriculum.map((plan: any) => plan.level);
      const uniqueLevelIds = [...new Set(levelIds)].filter(Boolean);

      // Use passed levelsData if available, otherwise fall back to state
      const levelsToUse = levelsData || levels;

      const curriculumLevelsList: any = uniqueLevelIds
        .map((levelId: string) => {
          return levelsToUse.find((lev: any) => lev.id === levelId);
        })
        .filter(Boolean);

      setCurriculumLevels(curriculumLevelsList);

      if (curriculumLevelsList.length > 0) {
        setSelectedLevelId(curriculumLevelsList[0].id);
        form.setFieldsValue({
          level: curriculumLevelsList[0]?.id,
        });
      }
    } catch (error) {
      console.error('Error fetching plan details:', error);
      throw error;
    }
  };

  return (
    <>
      <Modal
        title="Edit Class Curriculum and Levels"
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        width={600}>
        <Form form={form} layout="vertical">
          <Form.Item label="Curriculum" name="curriculum">
            <Select
              value={selectedCurriculumId}
              showSearch
              placeholder="Select a Curriculum"
              optionFilterProp="children"
              filterOption={false}
              onSearch={value => setSearchQuery(value)}
              onChange={value => {
                setSelectedCurriculumId(value);
                detectCurriculumLevelsByPlans(value);
              }}
              style={{width: '100%'}}>
              {filteredCurriculums.map((curriculum: any) => (
                <Select.Option
                  key={curriculum.id || curriculum._id}
                  value={curriculum.id || curriculum._id}>
                  {curriculum.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {curriculumLevels.length > 0 && (
            <Form.Item label="Level" name="level">
              <Select
                value={selectedLevelId}
                showSearch
                placeholder="Select a Level"
                optionFilterProp="children"
                onChange={value => setSelectedLevelId(value)}
                optionLabelProp="label"
                style={{width: '100%'}}>
                {curriculumLevels?.map((level: any) => (
                  <Select.Option
                    key={level.id || level._id}
                    value={level.id || level._id}
                    label={level.name}>
                    {level.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {loading && (
            <Spin
              size="large"
              style={{
                margin: 'auto',
                width: '100%',
                position: 'absolute',
                top: '50%',
                left: '48%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          )}
        </Form>
      </Modal>
    </>
  );
};
